import {
  ApiResponseError,
  ApiSessionTimeoutError,
  classifyApiError,
  unwrapResponseModel
} from '../api/responseModel';

export {
  ApiResponseError as CorrelatividadesApiError,
  ApiSessionTimeoutError as CorrelatividadesSessionTimeoutError,
  classifyApiError as classifyCorrelatividadesError,
  unwrapResponseModel
};

export function toSaveCorrelatividadCursarPayload({ materiaInicialCod, materiaCorrelativaCod, condicion }) {
  return {
    MateriaCarreraCod1: materiaInicialCod,
    MateriaCarreraCod: materiaCorrelativaCod,
    CorrelatividadCursarCondicion: condicion
  };
}

export function toUpdateCorrelatividadCursarPayload({ id, materiaInicialCod, materiaCorrelativaCod, condicion }) {
  return {
    CorrelatividadCursarCod: id,
    MateriaCarreraCod1: materiaInicialCod,
    MateriaCarreraCod: materiaCorrelativaCod,
    CorrelatividadRendirCondicion: condicion
  };
}

export function toSaveCorrelatividadRendirPayload({ materiaInicialCod, materiaCorrelativaCod, condicion }) {
  return {
    MateriaCarreraCod: materiaInicialCod,
    MateriaCarreraCod2: materiaCorrelativaCod,
    CorrelatividadRendirCondicion: condicion
  };
}

export function toUpdateCorrelatividadRendirPayload({ id, materiaInicialCod, materiaCorrelativaCod, condicion }) {
  return {
    CorrelatividadRendirCod: id,
    MateriaCarreraCod2: materiaInicialCod,
    MateriaCarreraCod: materiaCorrelativaCod,
    CorrelatividadRendirCondicion: condicion
  };
}

export function validateCorrelatividadForm({ materiaInicialPresent, condicionPresent }) {
  return Boolean(materiaInicialPresent && condicionPresent);
}
